import { c as _c } from "react/compiler-runtime";
import './child-bio-details.scss';
import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';
import { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { key, templateString } from '@sola/shared-utils/children/bio.ts';
export const ChildBioDetailsOverview = t0 => {
  const $ = _c(76);
  const {
    seoLevel: t1,
    details
  } = t0;
  const seoLevel = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["bio", "core"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  const CompContentHeading = `h${seoLevel + 2}` as ElementType;
  let t3;
  if ($[1] !== details.education.gradeLevel.us || $[2] !== t) {
    t3 = details.education.gradeLevel.us?.replace("University Level", t("bio:universityLevel")).replace("Preschool", t("bio:preschool")).replace("Not Currently Enrolled", t("bio:notCurrentlyEnrolled"));
    $[1] = details.education.gradeLevel.us;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const translatedGrade = t3;
  let t4;
  if ($[4] !== t) {
    t4 = t("bio:performanceAverage");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let gradePerformance = t4;
  if (details.education.academicPerformance?.toString() === "Below Average") {
    let t5;
    if ($[6] !== t) {
      t5 = t("bio:performanceBelow");
      $[6] = t;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    gradePerformance = t5;
  }
  if (details.education.academicPerformance?.toString() === "Above Average") {
    let t5;
    if ($[8] !== t) {
      t5 = t("bio:performanceAbove");
      $[8] = t;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    gradePerformance = t5;
  }
  if (details.education.academicPerformance?.toString() === "Not Available") {
    let t5;
    if ($[10] !== t) {
      t5 = t("bio:performanceUnavailable");
      $[10] = t;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    gradePerformance = t5;
  }
  let t5;
  if ($[12] !== CompContentHeading || $[13] !== details.education.notEnrolledInEducationReason || $[14] !== details.householdDuty || $[15] !== details.householdList[0].femaleGuardian.employmentStatus || $[16] !== details.householdList[0].femaleGuardian.occupation || $[17] !== details.householdList[0].householdMemberList || $[18] !== details.householdList[0].maleGuardian.employmentStatus || $[19] !== details.householdList[0].maleGuardian.occupation || $[20] !== details.householdList[0].parents || $[21] !== details.householdList[0].siblings || $[22] !== details.interests.favoriteProjectActivity || $[23] !== details.interests.thingsILike || $[24] !== gradePerformance || $[25] !== t || $[26] !== translatedGrade) {
    const fathersJobKey = key("bio:", details.householdList[0].maleGuardian.occupation || "unknown").concat("_Male");
    const motherJobKey = key("bio:", details.householdList[0].femaleGuardian.occupation || "unknown").concat("_Female");
    let t6;
    if ($[28] !== t) {
      t6 = t("bio:schooling");
      $[28] = t;
      $[29] = t6;
    } else {
      t6 = $[29];
    }
    let t7;
    if ($[30] !== CompContentHeading || $[31] !== t6) {
      t7 = <CompContentHeading className="label-potent label-xl">{t6}</CompContentHeading>;
      $[30] = CompContentHeading;
      $[31] = t6;
      $[32] = t7;
    } else {
      t7 = $[32];
    }
    let t8;
    if ($[33] !== t) {
      t8 = t("bio:grade");
      $[33] = t;
      $[34] = t8;
    } else {
      t8 = $[34];
    }
    let t9;
    if ($[35] !== t8 || $[36] !== translatedGrade) {
      t9 = <li>{t8}{translatedGrade}</li>;
      $[35] = t8;
      $[36] = translatedGrade;
      $[37] = t9;
    } else {
      t9 = $[37];
    }
    let t10;
    if ($[38] !== t) {
      t10 = t("bio:performance");
      $[38] = t;
      $[39] = t10;
    } else {
      t10 = $[39];
    }
    let t11;
    if ($[40] !== gradePerformance || $[41] !== t10) {
      t11 = <li>{t10}{gradePerformance}</li>;
      $[40] = gradePerformance;
      $[41] = t10;
      $[42] = t11;
    } else {
      t11 = $[42];
    }
    let t12;
    if ($[43] !== details.education.notEnrolledInEducationReason || $[44] !== t) {
      t12 = details.education.notEnrolledInEducationReason ? t("bio:childNotAttending") : t("bio:childAttending");
      $[43] = details.education.notEnrolledInEducationReason;
      $[44] = t;
      $[45] = t12;
    } else {
      t12 = $[45];
    }
    let t13;
    if ($[46] !== t12) {
      t13 = <li>{t12}</li>;
      $[46] = t12;
      $[47] = t13;
    } else {
      t13 = $[47];
    }
    let t14;
    if ($[48] !== t11 || $[49] !== t13 || $[50] !== t9) {
      t14 = <ul>{t9}{t11}{t13}</ul>;
      $[48] = t11;
      $[49] = t13;
      $[50] = t9;
      $[51] = t14;
    } else {
      t14 = $[51];
    }
    let t15;
    if ($[52] !== t) {
      t15 = t("bio:familyDuties");
      $[52] = t;
      $[53] = t15;
    } else {
      t15 = $[53];
    }
    let t16;
    if ($[54] !== CompContentHeading || $[55] !== t15) {
      t16 = <CompContentHeading className="label-potent label-xl">{t15}</CompContentHeading>;
      $[54] = CompContentHeading;
      $[55] = t15;
      $[56] = t16;
    } else {
      t16 = $[56];
    }
    let t17;
    if ($[57] !== details.householdDuty || $[58] !== t) {
      t17 = details.householdDuty?.map(item => <li key={item}>{t(templateString("bio:", item))}</li>);
      $[57] = details.householdDuty;
      $[58] = t;
      $[59] = t17;
    } else {
      t17 = $[59];
    }
    let t18;
    if ($[60] !== t17) {
      t18 = <ul>{t17}</ul>;
      $[60] = t17;
      $[61] = t18;
    } else {
      t18 = $[61];
    }
    let t19;
    if ($[62] !== t) {
      t19 = t("bio:hobbiesAndSports");
      $[62] = t;
      $[63] = t19;
    } else {
      t19 = $[63];
    }
    let t20;
    if ($[64] !== CompContentHeading || $[65] !== t19) {
      t20 = <CompContentHeading className="label-potent label-xl">{t19}</CompContentHeading>;
      $[64] = CompContentHeading;
      $[65] = t19;
      $[66] = t20;
    } else {
      t20 = $[66];
    }
    let t21;
    if ($[67] !== details.interests.thingsILike || $[68] !== t) {
      t21 = details.interests.thingsILike?.map(item_0 => <li key={item_0}>{t(templateString("bio:", item_0))}</li>);
      $[67] = details.interests.thingsILike;
      $[68] = t;
      $[69] = t21;
    } else {
      t21 = $[69];
    }
    let t22;
    if ($[70] !== details.interests.favoriteProjectActivity || $[71] !== t) {
      t22 = details.interests.favoriteProjectActivity?.map(item_1 => <li key={item_1}>{t(templateString("bio:", item_1))}</li>);
      $[70] = details.interests.favoriteProjectActivity;
      $[71] = t;
      $[72] = t22;
    } else {
      t22 = $[72];
    }
    let t23;
    if ($[73] !== t21 || $[74] !== t22) {
      t23 = <ul>{t21}{t22}</ul>;
      $[73] = t21;
      $[74] = t22;
      $[75] = t23;
    } else {
      t23 = $[75];
    }
    t5 = <div>{t7}{t14}{t16}{t18}{t20}{t23}{details.householdList[0].householdMemberList && details.householdList[0].householdMemberList?.length > 0 && <><CompContentHeading className="label-potent label-xl">{t("bio:familyInformation")}</CompContentHeading><ul><li>{t("bio:siblingsNumber")}{Number(details.householdList[0].siblings.numberOfBrothers) + Number(details.householdList[0].siblings.numberOfSisters)}</li><li>{t("bio:parentsMaritalStatus")}{t(templateString("bio:relationship", details.householdList[0].parents.maritalStatus || ""))}</li><li>{details.householdList[0].parents.naturalFather.isLivingWithChild ? t("bio:fatherWithChild") : t("bio:fatherNotWithChild")}</li><li>{details.householdList[0].parents.naturalMother.isLivingWithChild ? t("bio:motherWithChild") : t("bio:motherNotWithChild")}</li></ul><CompContentHeading className="label-potent label-xl">{t("bio:guardians")}</CompContentHeading><ul><li>{t("bio:fatherEmployment")}{t(fathersJobKey as unknown as TemplateStringsArray)}</li><li>{t("bio:fatherEmploymentStatus")}{details.householdList[0].maleGuardian.employmentStatus && t(templateString("bio:employment", details.householdList[0].maleGuardian.employmentStatus))}</li><li>{t("bio:motherEmployment")}{t(motherJobKey as unknown as TemplateStringsArray)}</li><li>{t("bio:motherEmploymentStatus")}{details.householdList[0].femaleGuardian.employmentStatus && t(templateString("bio:employment", details.householdList[0].femaleGuardian.employmentStatus))}</li></ul></>}</div>;
    $[12] = CompContentHeading;
    $[13] = details.education.notEnrolledInEducationReason;
    $[14] = details.householdDuty;
    $[15] = details.householdList[0].femaleGuardian.employmentStatus;
    $[16] = details.householdList[0].femaleGuardian.occupation;
    $[17] = details.householdList[0].householdMemberList;
    $[18] = details.householdList[0].maleGuardian.employmentStatus;
    $[19] = details.householdList[0].maleGuardian.occupation;
    $[20] = details.householdList[0].parents;
    $[21] = details.householdList[0].siblings;
    $[22] = details.interests.favoriteProjectActivity;
    $[23] = details.interests.thingsILike;
    $[24] = gradePerformance;
    $[25] = t;
    $[26] = translatedGrade;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  return t5;
};